import React, { useState } from "react";
import { PageSection } from "@design-system/PageSection/PageSection";
import type { SpaceStep } from "@design-system/FlexLayout/layout.types";
import { BooleanControl, SelectControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

const gapOptions = ["8", "16", "24", "32"] as const;
type GapOption = (typeof gapOptions)[number];

const gaps: Record<GapOption, SpaceStep> = {
    "8": 8,
    "16": 16,
    "24": 24,
    "32": 32,
};

export const PageSectionPlayground = () => {
    const [gap, setGap] = useState<GapOption>("16");
    const [hasInlinePadding, setHasInlinePadding] = useState(true);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Spacing</h2>
                        <div className={styles.fields}>
                            <SelectControl
                                label="Gap"
                                options={gapOptions}
                                value={gap}
                                onChange={setGap}
                            />
                        </div>
                    </section>
                    <section>
                        <h2>Features</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Inline padding"
                                checked={hasInlinePadding}
                                onChange={setHasInlinePadding}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`${gap}px gap`}
                alignment="start"
                width="full"
                output={JSON.stringify(
                    {
                        componentProps: {
                            gap: gaps[gap],
                            noPaddingInline: !hasInlinePadding,
                        },
                        showcaseState: {},
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.pageSectionSurface}>
                    <PageSection
                        gap={gaps[gap]}
                        noPaddingInline={!hasInlinePadding}
                    >
                        <div className={styles.contentBlock}>
                            <h3>Client workspace</h3>
                            <p>
                                Manage bookkeeping settings and collaborators.
                            </p>
                        </div>
                        <div className={styles.surface}>
                            <div className={styles.contentBlock}>
                                <h3>Bookkeeping preferences</h3>
                                <p>
                                    Configure reporting periods and review
                                    workflows.
                                </p>
                            </div>
                        </div>
                    </PageSection>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
